export const CONTENT_MAX_WIDTH = 1200
export const HOME_MAP_DARK_MODE = true
